import React from 'react';
import { useTranslation } from 'react-i18next';
import { BuildingLinkCode, BuildingOrg } from 'shared/models';
import { propertyNameLabelKeys } from '../orgRoles';
import { ClickToCopy } from 'ui/shared/containers';

require('./BuildingLinkCodesListItem.css');

export type Props = {
    linkCode: BuildingLinkCode;
    onClickDelete(): void;
};

export const BuildingLinkCodesListItem = ({ linkCode, onClickDelete }: Props) => {
    const { t } = useTranslation();
    const { properties } = linkCode;
    const typeString =
        (Object.keys(properties) as (keyof BuildingOrg['properties'])[])
            .filter(n => !!properties[n])
            .map(n => t(propertyNameLabelKeys[n]))
            .join(', ');
    return (
        <tr
            id={ `blcli-${linkCode.linkCode}` }
            className="building-link-codes-list-item"
        >
            <td>
                <ClickToCopy className="_code">
                    { `${linkCode.linkCode.substr(0, 4)}-${linkCode.linkCode.substr(4)}`.toUpperCase() }
                </ClickToCopy>
                <div className="_type">
                    { typeString }
                </div>
            </td>
            <td>
                <button
                    type="button"
                    className="ui tiny basic icon button"
                    onClick={ onClickDelete }
                    title={ t('COMMAND.DELETE') }
                >
                    <i className="remove icon"/>
                </button>
            </td>
        </tr>
    );
};
